import { PagesizeType } from '../../service/pagination/pagesize-type';
import { EventStore } from 'app/event/service/event.store';
import { Component, OnInit, Input } from '@angular/core';
import { Reservation } from '../../models/reservation';
import { ReservationStore } from '../../service/reservation-store';
import { StaySummary } from '../../models/stay-summary';
import { ReservationStatusCode } from '../../models/reservation-status-code.enum';
import { OnyxEvent } from '../../models/event';
import { ReservationUtils } from '../../utils/reservation-utils';
import { Page } from '../../../shared/models/page';
import { UserLocalStorageService } from '../../../permission/services/user.local.storage.service';

@Component({
  selector: 'pioneer-payment-reservations',
  templateUrl: './payment-reservations.component.html'
})
export class PaymentReservationsComponent implements OnInit {

  public onyxEvent: OnyxEvent;

  public reservationsPage: Page<Reservation>;
  public staySummary: StaySummary;

  pagesizeType = PagesizeType.PAYMENT_RESERVATIONS;

  constructor(private reservationStore: ReservationStore,
    private eventStore: EventStore,
    private userLocalStorageService: UserLocalStorageService) {
  }

  @Input('event')
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  ngOnInit() {
    this.goToRecordsPage(0);
    this.eventStore.getStaySummary(this.onyxEvent)
      .map(staySummary => this.staySummary = staySummary)
      .take(1)
      .subscribe();
  }

  goToRecordsPage(pageNumber: number) {
    this.reservationStore.getReservationsByStatus(this.onyxEvent.eventId, [ ReservationStatusCode.CHECKED_OUT ],
      pageNumber, this.userLocalStorageService.getPagesize(PagesizeType.PAYMENT_RESERVATIONS))
      .map(page => this.reservationsPage = page )
      .take(1)
      .subscribe();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/payment/reservations/payment-reservations.component.ts